import React from "react";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import ThemeNavDropdown from "../dropdowns/ThemeNavDropdown";

const HomePageNavbar = () => {
    const { t } = useTranslation();
    const menuPos = ["classesInPT", "studio", "instructors", "schedule", "faq", "contact"];

    return (
        <Navbar expand="lg" sticky="top" id="homePageNavbar">
            <Container>
                <Navbar.Brand href="/">
                    <Image src="/images/pt_logo.svg" alt="pole therapy logo" className="logo-navbar" />
                </Navbar.Brand>
                {/* <ThemeNavDropdown /> */}
                <Navbar.Toggle aria-controls="basicNavBar" />
                <Navbar.Collapse id="basicNavBar">
                    <Nav className="me-auto"></Nav>
                    <Nav>
                        {menuPos.map((e, i) => (
                            <Nav.Link key={i} href={`#${e}`}>
                                {t(`menu.${e}`)}
                            </Nav.Link>
                        ))}
                        <a
                            href={`${process.env.REACT_APP_URL}/app`}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={t("schedule.signUpForClassAriaLabel")}
                            className="nav-link btn btn-primary"
                        >
                            <FontAwesomeIcon icon={faRightToBracket} className="me-2" />
                            {t("logIn")}
                        </a>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default HomePageNavbar;
